/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react';
import { CustomerProfileModel } from '../../../models/customerProfile';
import axios from '../../../lib/axios';
import { CountCustomerModel } from '../../../models/countCustomer';
import { StatusEnum } from '../../../enums/status';
import { SelectChangeEvent } from '@mui/material/Select';
import {
  DEFAULT_FIRST_GET_DATA_AMOUNT,
  DEFAULT_ROWS_PER_PAGE,
  FETCH_MORE_DATA_AMOUNT,
} from '../../../config-global';
import { COUNT_NUMBER_CUSTOMER, CUSTOMER_FIND_MANY } from '../../../lib/endpoints/customer';
import { convertDateStringToNormalString } from '../../../utils/convertDateFormat';
import moment from 'moment';

export const useCustomerControllers = () => {
  const [data, setData] = useState<CustomerProfileModel[]>([]);
  const [countCustomer, setCountCustomer] = useState<CountCustomerModel>(null!);
  const [selectedID, setSelectedID] = useState<string>(null!);
  const [selectedProfile, setSelectedProfile] = useState<CustomerProfileModel>(null!);
  const [openMenu, setOpenMenu] = useState(null);
  const [openForm, setOpenForm] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [tabStatus, setTabStatus] = useState<StatusEnum>(StatusEnum.ALL);
  const [loadingDataMore, setLoadingDataMore] = useState<boolean>(false);
  const [loadingData, setLoadingData] = useState<boolean>(false);
  const [loadingSearchData, setLoadingSearchData] = useState<boolean>(false);
  const [selectedOption, setSelectedOption] = useState('fullName');
  const [loadingCount, setLoadingCount] = useState<boolean>(false);
  const [registerDate, setRegisterDate] = useState<any>(null!);
  const [endDate, setEndDate] = useState<any>(null!);

  const search = useRef<HTMLInputElement>(null!);

  //------ Function -------- //

  const handleSelectedOption = (event: SelectChangeEvent) => {
    setSelectedOption(event.target.value as string);
  };

  const handleOpenFormCustomer = () => {
    setOpenForm(!openForm);
    const getData = data?.filter((item) => item.customer?.id && item.profile?.id === selectedID)[0];
    setSelectedProfile(getData);
  };

  const handleCloseFormCustomer = () => {
    setOpenForm(false);
    setOpenMenu(null);
  };

  const handleOpenMenu = (event: any, getId: string) => {
    setOpenMenu(event.currentTarget);
    setSelectedID(getId);
  };

  const handleCloseMenu = () => {
    setOpenMenu(null);
  };

  const handleChangePage = (event: any, newPage: any) => {
    if (newPage === countPagination) {
      if (!loadingDataMore) {
        // handleFetchDataMore();
      }
    }
    setCurrentPage(newPage);
  };

  const handleSelectRegisterDate = (event: any) => {
    setRegisterDate(event.target.value);
  };

  //------ Filter Data -------- //
  const filterByRegisterDate: CustomerProfileModel[] = data?.filter(
    (data: CustomerProfileModel) => {
      if (registerDate && endDate) {
        const startDateTime = new Date(registerDate);
        startDateTime.setDate(startDateTime.getDate() - 1);
        const endDateTime = new Date(endDate);
        endDateTime.setDate(endDateTime.getDate() + 1);
        const startDateTimeISO = startDateTime.toISOString();
        const endDateTimeISO = endDateTime.toISOString();
        return (
          startDateTimeISO <= data?.customer?.createdAt &&
          data?.customer?.createdAt <= endDateTimeISO
        );
      } else {
        return true;
      }
    }
  );

  const filterDataByStatus: CustomerProfileModel[] = filterByRegisterDate?.filter(
    (item: CustomerProfileModel) => {
      if (tabStatus === StatusEnum.ALL) {
        return true;
      } else if (tabStatus === StatusEnum.ACTIVE) {
        return item.customer.isBan === false;
      } else if (tabStatus === StatusEnum.INACTIVE) {
        return item.customer.isBan === true;
      } else {
        return false;
      }
    }
  );

  const filterData = filterDataByStatus;

  const rows: CustomerProfileModel[] = filterData.slice(
    (currentPage - 1) * DEFAULT_ROWS_PER_PAGE,
    currentPage * DEFAULT_ROWS_PER_PAGE
  );

  const countPagination = Math.ceil(filterData.length / DEFAULT_ROWS_PER_PAGE);
  // const countData = Math.ceil(data?.length / 10);
  const allCustomer = countCustomer?.data?.allCustomer;
  const isActiveCustomer = countCustomer?.data?.isActive;
  const isBannedCustomer = countCustomer?.data?.Banned;

  //------ Fetch Data -------- //

  // const handleFetchDataMore = async () => {
  //   try {
  //     setLoadingDataMore(true);
  //     const res = await axios.post(
  //       `${CUSTOMER_FIND_MANY}?page=${countData}&limit=${countCustomer.data?.allCustomer.toString()}`
  //     );
  //     console.log(res);
  //     const newData = [...data, ...res?.data.data];
  //     setData(newData);
  //   } catch (err) {
  //     console.log(err);
  //   } finally {
  //     setLoadingDataMore(false);
  //   }
  // };

  const handleFetchData = async () => {
    try {
      setLoadingData(true);
      const resCountCustomer = await axios.post(`${COUNT_NUMBER_CUSTOMER}`);
      const resCustomerProfile = await axios.post(`${CUSTOMER_FIND_MANY}?limit=${1000000}`);

      setCountCustomer(resCountCustomer?.data);
      setData(resCustomerProfile.data?.data);
    } catch (err) {
      // console.log('error=', err);
    } finally {
      setLoadingData(false);
    }
  };

  const handleGetData = async () => {
    try {
      setLoadingData(true);
      await handleFetchData();
    } catch (err) {
      // console.log('Error', err);
    } finally {
      setLoadingData(false);
    }
  };

  const handleFetchFilterCustomer = async () => {
    try {
      setLoadingSearchData(true);
      const filter: any = {};
      if (selectedOption === 'email') {
        filter.email = search.current.value;
      } else if (selectedOption === 'fullName') {
        filter.fullName = search.current.value;
      } else if (selectedOption === 'phone') {
        filter.phone = search.current.value;
      }
      const res = await axios.post(
        `${CUSTOMER_FIND_MANY}?limit=${countCustomer.data?.allCustomer.toString()}`,
        filter
      );

      const getData = res?.data?.data;
      setCurrentPage(1);
      if (getData.length > 0) {
        setData(getData);
      } else {
        setData([]);
      }
    } catch (err) {
      window.alert('Server error please try again');
    } finally {
      setLoadingSearchData(false);
    }
  };

  //------ useEffect -------- //

  useEffect(() => {
    handleGetData();
  }, []);

  return {
    rows,
    filterData,
    currentPage,
    handleChangePage,
    handleOpenMenu,
    openMenu,
    handleCloseMenu,
    openForm,
    handleOpenFormCustomer,
    handleCloseFormCustomer,
    data,
    countPagination,
    selectedProfile,
    allCustomer,
    isActiveCustomer,
    isBannedCustomer,
    selectProfile: (NewValue: CustomerProfileModel) => setSelectedProfile(NewValue),
    handleSetTabStatus: (newValue: StatusEnum) => {
      setTabStatus(newValue);
      setCurrentPage(1);
    },
    tabStatus,
    loadingData,
    handleFetchData,
    handleSelectedOption,
    selectedOption,
    handleFetchFilterCustomer,
    loadingCount,
    loadingDataMore,
    search,
    loadingSearchData,
    handleSelectRegisterDate,
    registerDate,
    endDate,
    setEndDate,
  };
};
